"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _setTimeout2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set-timeout"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * Higher Order Component for scrolling a wrapped component into view on mount.
 * For it's child, it takes a function with a single ref param that will return
 * a React component that assigns that ref.
 */
const MountScroller = _ref => {
  let {
    children,
    alignToTop,
    delay = 0
  } = _ref;
  // Create the ref to pass to the child
  const childRef = /*#__PURE__*/(0, _react.createRef)();

  // Scroll the child into view only on mount
  (0, _react.useEffect)(() => {
    const timeout = (0, _setTimeout2.default)(() => {
      if (childRef.current && childRef.current.scrollIntoView) {
        childRef.current.scrollIntoView(alignToTop);
      }
    }, delay);
    return () => clearTimeout(timeout);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, children(childRef));
};
MountScroller.propTypes = {
  /**
   * A function that takes in a React.RefObject and returns a component with
   * that ref assigned to it.
   */
  children: _propTypes.default.func.isRequired,
  /**
   * Whether or not the scrollIntoView call is made with alignToTop set.
   */
  alignToTop: _propTypes.default.bool,
  /**
   * Delay to add to the scrollIntoView call (ms)
   */
  delay: _propTypes.default.number
};
var _default = exports.default = MountScroller;
MountScroller.__docgenInfo = {
  "description": "Higher Order Component for scrolling a wrapped component into view on mount.\nFor it's child, it takes a function with a single ref param that will return\na React component that assigns that ref.",
  "methods": [],
  "displayName": "MountScroller",
  "props": {
    "delay": {
      "defaultValue": {
        "value": "0",
        "computed": false
      },
      "description": "Delay to add to the scrollIntoView call (ms)",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "children": {
      "description": "A function that takes in a React.RefObject and returns a component with\nthat ref assigned to it.",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "alignToTop": {
      "description": "Whether or not the scrollIntoView call is made with alignToTop set.",
      "type": {
        "name": "bool"
      },
      "required": false
    }
  }
};